var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.327 4.12701C12.0299 3.42407 13.1696 3.42407 13.8726 4.12701C14.5755 4.82996 14.5755 5.96965 13.8726 6.6726L11.1726 9.3726C10.4696 10.0755 9.32994 10.0755 8.627 9.3726C8.27553 9.02112 7.70568 9.02112 7.3542 9.3726C7.00273 9.72407 7.00273 10.2939 7.3542 10.6454C8.76009 12.0513 11.0395 12.0513 12.4454 10.6454L15.1454 7.94539C16.5513 6.5395 16.5513 4.26011 15.1454 2.85422C13.7395 1.44833 11.4601 1.44833 10.0542 2.85422L8.70421 4.20422C8.35273 4.55569 8.35273 5.12554 8.70421 5.47701C9.05568 5.82848 9.62553 5.82848 9.977 5.47701L11.327 4.12701Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82701 8.62701C7.52996 7.92407 8.66965 7.92407 9.3726 8.62701C9.72407 8.97848 10.2939 8.97848 10.6454 8.62701C10.9969 8.27554 10.9969 7.70569 10.6454 7.35422C9.2395 5.94833 6.96011 5.94833 5.55422 7.35422L2.85422 10.0542C1.44833 11.4601 1.44833 13.7395 2.85422 15.1454C4.26011 16.5513 6.5395 16.5513 7.94539 15.1454L9.29539 13.7954C9.64686 13.4439 9.64686 12.8741 9.29539 12.5226C8.94392 12.1711 8.37407 12.1711 8.0226 12.5226L6.6726 13.8726C5.96965 14.5755 4.82996 14.5755 4.12701 13.8726C3.42407 13.1697 3.42407 12.03 4.12701 11.327L6.82701 8.62701Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.db1cd6267e78a81296964a49f18cbe23.svg";
export { ForwardRef as ReactComponent };